export const withoutTwoSpacesInRowRegexp: RegExp = new RegExp(/^((?!\s{2}).)*$/);
